import React from "react";
import { Table2 } from "lucide-react";

/**
 * Table-column chips for one page. Columns are opt-OUT (default visible):
 * filled chip = visible, outlined chip = hidden. Clicking flips it.
 * hiddenColumns holds "{tableKey}.{columnKey}": true for hidden columns.
 */
const ColumnToggleList = ({ page, hiddenColumns, onToggleColumn, theme, language, t, disabled = false }) => {
  const tables = page?.tables || [];
  if (!tables.length) return null;

  const headColor = theme === "dark" ? "#94a3b8" : "#64748b";

  return (
    <div style={{ display: "flex", flexDirection: "column", gap: "14px" }}>
      <div style={{
        display: "flex", alignItems: "center", gap: "6px",
        fontSize: "11px", fontWeight: 700, letterSpacing: "0.06em",
        textTransform: "uppercase", color: headColor,
      }}>
        <Table2 size={12} />
        {t.columnsTitle}
      </div>
      {tables.map((table) => (
        <div key={table.key}>
          <div style={{
            fontSize: "12.5px", fontWeight: 600, marginBottom: "8px",
            color: theme === "dark" ? "#cbd5e1" : "#475569",
          }}>
            {table.labels?.[language] || table.labels?.en || table.key}
          </div>
          <div style={{ display: "flex", flexWrap: "wrap", gap: "8px" }}>
            {(table.columns || []).map((column) => {
              const fullKey = `${table.key}.${column.key}`;
              const hidden = !!hiddenColumns?.[fullKey];
              return (
                <button
                  key={column.key}
                  type="button"
                  disabled={disabled}
                  onClick={() => { if (!disabled) onToggleColumn(page.key, table.key, column.key, hidden); }}
                  title={t.columnsHint}
                  style={{
                    padding: "6px 14px",
                    borderRadius: "999px",
                    fontSize: "12.5px",
                    fontWeight: 600,
                    fontFamily: "inherit",
                    cursor: disabled ? "not-allowed" : "pointer",
                    opacity: disabled ? 0.55 : 1,
                    transition: "all 0.18s ease",
                    textDecoration: hidden ? "line-through" : "none",
                    // filled = visible, outline = hidden
                    border: hidden
                      ? `1px dashed ${theme === "dark" ? "rgba(148,163,184,0.45)" : "rgba(100,116,139,0.45)"}`
                      : "1px solid transparent",
                    background: hidden
                      ? "transparent"
                      : (theme === "dark" ? "rgba(46,124,186,0.28)" : "rgba(46,124,186,0.12)"),
                    color: hidden
                      ? (theme === "dark" ? "#7c8aa0" : "#94a3b8")
                      : (theme === "dark" ? "#8ec2ec" : "#1e5a96"),
                  }}
                >
                  {column.labels?.[language] || column.labels?.en || column.key}
                </button>
              );
            })}
          </div>
        </div>
      ))}
      <div style={{ fontSize: "11.5px", color: headColor, fontStyle: "italic" }}>
        {t.columnsHint}
      </div>
    </div>
  );
};

export default ColumnToggleList;
